import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ContractCaseLog } from "../_types/contract-case-log";
import { ContractCaseType } from "../_types/contract-case-type";

@Injectable({
  providedIn: 'root',
})
export class ContractCaseTypesService extends Service<ContractCaseType> {
  public override type = 'contractsCaseTypes';
  public override url = 'attendance/contractsCaseTypes';
}